export default __webpack_public_path__ + "bc698545abbd7cac452764053fe8b547.png";